/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDName } from './IDName';
import {
    IDNameFromJSON,
    IDNameFromJSONTyped,
    IDNameToJSON,
    IDNameToJSONTyped,
} from './IDName';
import type { Branch } from './Branch';
import {
    BranchFromJSON,
    BranchFromJSONTyped,
    BranchToJSON,
    BranchToJSONTyped,
} from './Branch';

/**
 * 
 * @export
 * @interface OrdersListFilterOptionsResponse
 */
export interface OrdersListFilterOptionsResponse {
    /**
     * 
     * @type {Array<Branch>}
     * @memberof OrdersListFilterOptionsResponse
     */
    branches: Array<Branch>;
    /**
     * 
     * @type {Array<IDName>}
     * @memberof OrdersListFilterOptionsResponse
     */
    order_tags: Array<IDName>;
    /**
     * 
     * @type {Array<IDName>}
     * @memberof OrdersListFilterOptionsResponse
     */
    creators: Array<IDName>;
}

/**
 * Check if a given object implements the OrdersListFilterOptionsResponse interface.
 */
export function instanceOfOrdersListFilterOptionsResponse(value: object): value is OrdersListFilterOptionsResponse {
    if (!('branches' in value) || value['branches'] === undefined) return false;
    if (!('order_tags' in value) || value['order_tags'] === undefined) return false;
    if (!('creators' in value) || value['creators'] === undefined) return false;
    return true;
}

export function OrdersListFilterOptionsResponseFromJSON(json: any): OrdersListFilterOptionsResponse {
    return OrdersListFilterOptionsResponseFromJSONTyped(json, false);
}

export function OrdersListFilterOptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdersListFilterOptionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'branches': ((json['branches'] as Array<any>).map(BranchFromJSON)),
        'order_tags': ((json['order_tags'] as Array<any>).map(IDNameFromJSON)),
        'creators': ((json['creators'] as Array<any>).map(IDNameFromJSON)),
    };
}

export function OrdersListFilterOptionsResponseToJSON(json: any): OrdersListFilterOptionsResponse {
    return OrdersListFilterOptionsResponseToJSONTyped(json, false);
}

export function OrdersListFilterOptionsResponseToJSONTyped(value?: OrdersListFilterOptionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branches': ((value['branches'] as Array<any>).map(BranchToJSON)),
        'order_tags': ((value['order_tags'] as Array<any>).map(IDNameToJSON)),
        'creators': ((value['creators'] as Array<any>).map(IDNameToJSON)),
    };
}

